import {KeyVaultForm} from "../../api/Model";
import {inputChange, mapSetState, SetState} from "../../util/FormHandlers";
import React, {useMemo} from "react";
import {Stack, TextField} from "@mui/material";
import ColorPicker from "../../components/color-picker/ColorPicker";

export function KeyVaultDialog({form, setForm}: {
    form: KeyVaultForm;
    setForm: SetState<KeyVaultForm>;
}) {
    const handlers = useMemo(() => ({
        handleVaultNameChange: inputChange(setForm, newValue => ({
            name: newValue,
        })),
        setColor: mapSetState(setForm, 'color'),
    }), [setForm]);

    return form
        ? (
            <Stack spacing={2} direction="column" sx={{pt: 2}}>
                <ColorPicker
                    required
                    margin="dense"
                    id="color"
                    label="Color"
                    fullWidth
                    variant="outlined"
                    value={form.color}
                    onChange={handlers.setColor}
                    slotProps={{inputLabel: {shrink: true}}}
                />
                <TextField
                    required
                    autoFocus
                    margin="dense"
                    id="name"
                    label="Vault Name"
                    type="text"
                    fullWidth
                    variant="outlined"
                    value={form.name}
                    onChange={handlers.handleVaultNameChange}
                />
            </Stack>
        )
        : null;
}